// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"4feecd49","389":"1db9b652","427":"3344e721","457":"dca1c2b1","672":"cc6c3744","745":"9e8c1df4","828":"ddc36f20","842":"af8cbc84","851":"f0477da1"}[chunkId] + ".chunk.js";
};